import { tv } from 'tailwind-variants'

export const buttonVariants = tv({
  base: [
    'flex items-center justify-between',
    'h-6 min-h-6',
    'gap-2 px-2',
    '[text-shadow:0px_1px_1px_rgba(0,0,0,0.25)]',
    'rounded-10 shadow-white-top-accent-inset'
  ],
  variants: {
    status: {
      active: '',
      inactive: 'bg-white/10'
    },
    accentColor: {
      none: '',
      yellow: '',
      green: '',
      blue: ''
    }
  },
  defaultVariants: {
    status: 'inactive',
    accentColor: 'yellow'
  },
  compoundVariants: [
    {
      status: 'active',
      accentColor: 'yellow',
      class: 'bg-yellow-gradient'
    },
    {
      status: 'active',
      accentColor: 'green',
      class: 'bg-green-gradient'
    },
    {
      status: 'active',
      accentColor: 'blue',
      class: 'bg-blue-gradient'
    },
    {
      status: 'active',
      accentColor: 'none',
      class: 'bg-white/10'
    }
  ]
})
